exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__PasswordStrength__root {\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n  @media (max-width: 767px) {.DS__PasswordStrength__root {\r\n    width: 100%\r\n}\r\n  }\r\n\r\n.DS__PasswordStrength__visible {\r\n  display: block;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"root": "DS__PasswordStrength__root",
	"visible": "DS__PasswordStrength__visible"
};